// src/components/projects/ProjectsGrid/ProjectsGrid.jsx
import React, { useEffect, useMemo, useState } from "react";
import { FiChevronDown, FiGrid } from "react-icons/fi";
import ProjectCard from "./ProjectCard";
import "./ProjectsGrid.css";
import apis from "../../utils/apis";
import httpAction from "../../utils/httpAction";
import useGeneral from "../../hooks/useGeneral";

export default function ProjectsGrid() {
  const [projects, setProjects] = useState([]);
  const [locaton, setLocation] = useState([]);
  const { loading, setLoading } = useGeneral();
  const [filter, setFilter] = useState({
    location: "",
    construction: "",
    price: "",
  });

  const filterChange = (type, value) => {
    setFilter((prev) => ({ ...prev, [type]: value?.toLowerCase() }));
  };

  const getProjects = async () => {
    const qs = new URLSearchParams({
      location: filter.location || "",
      construction: filter.construction || "",
      price: filter.price || "",
    }).toString();

    const data = {
      url: `${apis().getProjectListingListAll}?${qs}`,
    };
    setLoading(true);
    const result = await httpAction(data);
    setLoading(false);
    if (result?.status) {
      setProjects(result?.list);
    }
  };

  const getGetLocations = async () => {
    const data = {
      url: apis().getLocationList,
    };
    const result = await httpAction(data);
    if (result?.status) {
      const formatedList = result?.list?.map((item) => item.title);
      setLocation(formatedList);
    }
  };

  useEffect(() => {
    getProjects();
  }, [filter]);

  useEffect(() => {
    getGetLocations();
  }, []);

  return (
    <section className="pjg">
      <div className="container">
        {/* Top bar */}
        <div className="pjg__top">
          <div className="pjg__summary">
            <span className="pjg__icon">
              <FiGrid />
            </span>
            <div>
              <div className="pjg__label">Projects</div>
              <div className="pjg__text">
                Showing <strong>{projects?.length}</strong>
              </div>
            </div>
          </div>

          <div className="pjg__filters">
            <div className="pjg__filter">
              <span className="pjg__fLabel">Location</span>
              <select
                onChange={(e) => filterChange("location", e.target.value)}
                className="pjg__select"
              >
                <option>All</option>
                {locaton?.map((item, index) => (
                  <option key={index}>{item}</option>
                ))}
              </select>
              <FiChevronDown className="pjg__chev" />
            </div>

            <div className="pjg__filter">
              <span className="pjg__fLabel">Status</span>
              <select
                onChange={(e) => filterChange("construction", e.target.value)}
                className="pjg__select"
              >
                <option>All</option>
                <option>Pre-Launch</option>
                <option>Under Construction</option>
                <option>Ready</option>
              </select>
              <FiChevronDown className="pjg__chev" />
            </div>

            <div className="pjg__filter">
              <span className="pjg__fLabel">Sort by price</span>
              <select
                onChange={(e) => filterChange("price", e.target.value)}
                className="pjg__select"
              >
                <option>All</option>
                <option>Low to high</option>
                <option>High to low</option>
              </select>
              <FiChevronDown className="pjg__chev" />
            </div>
          </div>
        </div>

        {/* Grid */}
        <div className="pjg__grid">
          {loading
            ? Array.from({ length: 6 }).map((_, i) => (
                <ProjectCard key={i} loading />
              ))
            : projects.map((p) => <ProjectCard key={p._id} item={p} />)}
        </div>
      </div>
    </section>
  );
}
